import { render } from "./broker_request_upgrade.vue?vue&type=template&id=f5b2441a&scoped=true&ts=true"
import script from "./broker_request_upgrade.vue?vue&type=script&lang=ts"
export * from "./broker_request_upgrade.vue?vue&type=script&lang=ts"

import "./broker_request_upgrade.vue?vue&type=style&index=0&id=f5b2441a&scoped=true&lang=css"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b2441a"]])

export default __exports__